import Vue from "vue";
import Router from "vue-router";
//系统
import login from "../views/login.vue";
import businessModel from "../views/businessModel.vue";
import meetlist from "../views/meetlist.vue";
import joinlist from "../views/meet/joinlist.vue";
import mblist from "../views/user/mblist.vue";
import aiorder from "../views/user/aiorder.vue";



import businessmodel from "../views/meet/businessmodel.vue";

import menuManagement from "../views/menuManagement.vue";
import cardManagement from "../views/card/cardManagement.vue";
import cardyslist from "../views/card/cardyslist.vue";

import cardrecord from "../views/card/cardrecord.vue";
import recordList from "../views/card/recordList.vue";
import version from "../views/version.vue";
import adminversion from "../views/adminversion.vue";
import roleManagement from "../views/roleManagement.vue";
import userManagement from "../views/userManagement.vue";
import unit from "../views/unit.vue";
import sysSetting from "../views/sysSetting.vue";
import home from "../views/home.vue";
import courseList from '../views/course/courseList.vue'
import emaillist from '../views/user/emaillist.vue'

import statistics from "../views/statistics.vue";
//用户
import userList from "../views/user/list.vue";
import qqlist from "../views/user/qqlist.vue";

import yuelist from "../views/store/yuelist.vue";
import ipob from "../views/store/ipob.vue";

import Jobsharing from "../views/store/Jobsharing.vue";
import setfc from "../views/store/setfc.vue";
import storeMessage from "../views/message/storeMessage.vue";
import joblist from "../views/store/joblist.vue";
import jobrecord from "../views/store/jobrecord.vue";
import searchList from "../views/user/searchList.vue";
import userRecord from "../views/user/record.vue";
import userContribute from "../views/user/userContribute.vue";

import consumptionPoints from "../views/user/consumptionPoints.vue"; //流量池变动记录
import userProperty from "../views/user/property.vue";
import userWithdraw from "../views/user/integralWithdrawalList.vue";
import userPool from "../views/user/pool.vue";
import jackpot from "../views/user/jackpot.vue";
import integralList from "../views/integral/list.vue";
//供应商列表
import storeList from "../views/store/list.vue";
//员工身份
import employeeList from "../views/store/employeeList.vue";
 import updateProductAttr from '../views/goods/updateProductAttr.vue'
 //添加属性列表
 import addProductAttr from '../views/goods/addProductAttr.vue'
import fxList from "../views/store/fxList.vue"
import storeexpress from "../views/store/storeexpress.vue"
import expressList from "../views/store/expressList.vue"

//品牌
import Pplist from "../views/store/Pplist.vue";
import Ppclass from "../views/store/Ppclass.vue"; 
//商品列表
import goodsList from "../views/goods/list.vue";
import goodsDetail from "../views/goods/goodsDetail.vue";
import productAttrList from "../views/goods/productAttrList.vue";

import offinegoods from "../views/goods/offinegoods.vue";

import PpGoods from "../views/goods/PpGoods.vue"; //云连锁商品

//社区商品列表
import goodsListOffline from "../views/storeOffline/listOffline.vue";
//商品分类
import goodsClass from "../views/goods/goodsClass.vue";
import ssgoodsclass from "../views/goods/ssgoodsclass.vue";
//社区商品分类
import goodsClassOffline from "../views/storeOffline/goodsClassOffline.vue";
//社区分类
import storeClassOffline from "../views/storeOffline/storeClassOffline.vue";
// 订单管理
import orderList from "../views/orderManagement/orderList"; //商户订单管理
import ssorderList from "../views/orderManagement/ssorderList"; //线下商户订单管理
import orderMang from "../views/orderManagement/orderMang"; //平台订单管理

import allianceOrderList from "../views/orderManagement/allianceOrderList"; //联盟订单
import news from "../views/posters/news.vue";
import mcs from "../views/posters/mcs.vue";
import users from "../views/posters/users.vue";

// 社区订单管理
import orderListOffline from "../views/storeOffline/orderListOffline";
// 物流管理
import logistics from "../views/logistics/index";
//省市区管理
import threeLevelAddress from "../views/logistics/threeLevelAddress";

import swiper from "../views/carousel/swiper.vue";
import wineCooler from "../views/store/wineCooler.vue";

//质押管理
import pledgemanage from "../views/pledgemanage/pledgemanage.vue";
//质押明细
import pledgeDetail from "../views/pledgemanage/pledgeDetail.vue";
//质押记录
import pledgeRecord from "../views/pledgemanage/pledgeRecord.vue";
//质押期数
import pledgePowerRecord from "../views/pledgemanage/pledgePowerRecord.vue";
//底池
import bottomBasin from "../views/pledgemanage/bottomBasin.vue";
//大区业绩日报表
import performanceReport from "../views/pledgemanage/performanceReport.vue";
//大区业绩月报表
import perfoReportmouth from "../views/pledgemanage/perfoReportmouth.vue";
//供应商管理
import storeManage from "../views/store/storeManage.vue";

//酒柜管理里面的商品列表
import productList from "../views/storeOffline/productList.vue";
//酒柜列表
import wineCabinetList from "../views/storeOffline/wineCabinetList.vue";

// 云库审核列表
import cloudList from "../views/store/cloudList.vue";
// 促销审核管理
import promoTion from "../views/dPromotion/promoTion.vue";
// 折扣促销列表
import promList from "../views/dPromotion/promList.vue";
//加入选品
import fxlist from "../views/dPromotion/fxlist.vue";
//选品库
import selectionlist from "../views/dPromotion/selectionlist.vue";

//商户提现
import mrRcList from "../views/mrRction/mrRcList.vue";
//商户提现管理
import mantWithManagement from "../views/mrRction/mantWithManagement.vue";
// 提现管理
import withdManagement from "../views/mrRction/withdManagement.vue";
// 质押、供应申请
import creditList from "../views/mrRction/creditList.vue";
// 信用分变动查询
import CreditScoreList from "../views/mrRction/CreditScoreList.vue";



// 定存列表
import fixdList from "../views/fixDeposit/fixdList.vue";
// 定存管理
import fixManage from "../views/fixDeposit/fixManage.vue";

//店铺经营类别管理
import bniesCategory from "../views/store/bniesCategory.vue";
import setoffstore from "../views/store/setoffstore.vue";
//推荐分类
import remondClass from "../views/goods/remondClass.vue";
import goxuanpin from "../views/goxuanpin.vue";
import goodsdetail from "../views/goodsdetail.vue";

import xuanping from "../views/xuanping.vue";

import notify from "../views/notify/list.vue";
//广告类型
import advertisingTypeList from '../views/notify/advertisingTypeList.vue'

import shoparea from "../views/Area/shoparea.vue";
import goodsarea from "../views/Area/goodsarea.vue";
import hytype from "../views/Area/hytype.vue";

//预约排单列表
import scheduling from "../views/appomplt/apmScheduling.vue";

//抢单额度
import orderGrabbing from "../views/appomplt/orderGrabbing.vue";

// 供应商商品管理
import goodSupplierlist from "../views/goods/goodSupplierlist.vue";
import orederSupplerlist from "../views/orderManagement/orederSupplerlist.vue"; //供应商订单管理

// 区域代理管理
import regionalAgent from "../views/regionalAgent/index";

// 抢购活动
import robOrder from "../views/goods/robOrder.vue";

// 抢购预约记录
import orderRecords from "../views/goods/orderRecords.vue";

// 采购订单管理
import orderPurchaselist from "../views/orderManagement/orderPurchaselist.vue";

// 会员买单记录
import buyRecords from "../views/otc/buyRecords.vue";

// OTC挂卖订单
import saleRecords from "../views/otc/saleRecords.vue";

// OTC价格变动
import priceChange from "../views/otc/priceChange.vue";

// OTC记录
import otcList from "../views/otc/otcList.vue";

// 经销商月度业绩
import dealerMPerformance from "../views/dealer/dealerMPerformance.vue";

// 资产变动记录-历史记录
import recordHistory from "../views/user/recordHistory.vue";

// 订单历史记录
import orderHistory from "../views/orderManagement/orderHistory.vue";

// 充值记录审核
import pay from "../views/user/pay.vue";
import glypay from "../views/user/glypay.vue";

// 消息管理
import messagesType from "../views/message/messagesType.vue"
import systemMessages from "../views/message/systemMessages.vue"

//反馈建议
import feedbackType from "../views/feedback/feedbackType.vue"
import queryFeedbackNode from "../views/feedback/queryFeedbackNode.vue"

import customerFeedback from "../views/feedback/customerFeedback" //客户反馈记录


//帮助中心
import helpList from "../views/help/helpList.vue";
//帮助中心
import helpTypeList from "../views/help/helpTypeList.vue";


import paymentByCode from "../views/store/paymentByCode"

// 短视频
import videoList from "../views/shortVideo/list"


import orderAfterSale from "../views/orderManagement/orderAfterSale"; //订单售后列表


import caiGouOrderList from "../views/orderManagement/caiGouOrderList"; //采购订单列表


import paymentList from "../views/livingPayment/paymentList"; //列表


import caseList from "../views/facilitator/caseList"; //案例列表

import fwsMonthResult from "../views/facilitator/fwsMonthResult"; //服务商月度业绩统计表


import storeMonthResult from "../views/store/storeMonthResult"; //商家月度业绩统计表


import assetChanges from "../views/store/assetChanges"; //商家资产变动



Vue.use(Router);

export default new Router({
  mode: process.env.NODE_ENV == "production" ? "hash" : "history",
  routes: [
    {
      path: "/",
      name: "index",
      component: login,
    },
    {
      path: "/xuanping",
      name: "xuanping",
      component: xuanping,
      meta: { hiddenSiderbar: false },
    },
	
    {
      path: "/goxuanpin",
      name: "goxuanpin",
      component: goxuanpin,
      meta: { hiddenSiderbar: false },
    },
    {
      //商品列表
      path: "/goodsdetail",
      name: "goodsdetail",
      component: goodsdetail,
      meta: { hiddenSiderbar: false },
    },
	
    {
      //首页
      path: "/home",
      name: "home",
      component: home,
    },
    {
      //统计
      path: "/statistics",
      name: "statistics",
      component: statistics,
    },
    {
      //菜单管理
      path: "/menuManagement",
      name: "menuManagement",
      component: menuManagement,
    },
	{
	  //版本管理
	  path: "/version",
	  name: "version",
	  component: version,
	},
	{
	  //模式管理
	  path: "/meetlist",
	  name: "meetlist",
	  component: meetlist,
	},
	{
	  //会议管理
	  path: "/businessModel",
	  name: "businessModel",
	  component: businessModel,
	},
	{
	  //后台版本管理
	  path: "/adminversion",
	  name: "adminversion",
	  component: adminversion,
	},
    {
      //角色管理
      path: "/roleManagement",
      name: "roleManagement",
      component: roleManagement,
    },
    {
      //用户管理
      path: "/userManagement",
      name: "userManagement",
      component: userManagement,
    },
    {
      //系统参数管理
      path: "/sysSetting",
      name: "sysSetting",
      component: sysSetting,
    },
	{
	  //单位管理
	  path: "/posters/news",
	  name: "news",
	  component: news,
	},
	{
	  //单位管理
	  path: "/posters/mcs",
	  name: "mcs",
	  component: mcs,
	},
	{
	  //单位管理
	  path: "/posters/users",
	  name: "users",
	  component: users,
	},
	{
	  //单位管理
	  path: "/store/ipob",
	  name: "ipob",
	  component: ipob,
	},
	{
	  //单位管理
	  path: "/store/setfc",
	  name: "setfc",
	  component: setfc,
	},
	
    {
      //单位管理
      path: "/unit",
      name: "unit",
      component: unit,
    },
    {
      //会员列表
      path: "/user/list",
      name: "userList",
      component: userList,
    },
	{
	  //会员列表
	  path: "/user/qqlist",
	  name: "qqlist",
	  component: qqlist,
	},
    {
      //会员列表
      path: "/Area/shoparea",
      name: "shoparea",
      component: shoparea,
    },
    {
      //
      path: "/Area/goodsarea",
      name: "goodsarea",
      component: goodsarea,
    },
	{
	  //
	  path: "/meet/joinlist",
	  name: "joinlist",
	  component: joinlist,
	},
	{
	  //
	  path: "/meet/businessmodel",
	  name: "businessmodel",
	  component: businessmodel,
	},
	
	{
	  //
	  path: "/Area/hytype",
	  name: "hytype",
	  component: hytype,
	},

    {
      //会员查询
      path: "/user/searchList",
      name: "searchList",
      component: searchList,
    },
    {
      //
      path: "/store/yuelist",
      name: "yuelist",
      component: yuelist,
    },
	{
	  //
	  path: "/store/joblist",
	  name: "joblist",
	  component: joblist,
	},
	{
	  //
	  path: "/store/jobrecord",
	  name: "jobrecord",
	  component: jobrecord,
	},
	{
	  //用户变账记录
	  path: "/user/userContribute",
	  name: "userContribute",
	  component: userContribute,
	},
    {
      //用户变账记录
      path: "/user/record",
      name: "userRecord",
      component: userRecord,
    },
	
    {
      //
      path: "/user/consumptionPoints",
      name: "consumptionPoints",
      component: consumptionPoints,
    },
    {
      //用户变账记录
      path: "/user/jackpot",
      name: "jackpot",
      component: jackpot, 
    },
    {
      //资产列表
      path: "/user/property",
      name: "userProperty",
      component: userProperty,
    },
    {
      //用户矿池
      path: "/user/pool",
      name: "userPool",
      component: userPool,
    },
    {
      //商品分类
      path: "/goods/goodsClass",
      name: "goodsClass",
      component: goodsClass,
    },
    {
      //社区商品分类
      path: "/storeOffline/goodsClassOffline",
      name: "goodsClassOffline",
      component: goodsClassOffline,
    },
	{
	  //社区商品分类
	  path: "/goods/ssgoodsclass",
	  name: "ssgoodsclass",
	  component: ssgoodsclass,
	},
	
    {
      //社区分类
      path: "/storeOffline/storeClassOffline",
      name: "storeClassOffline",
      component: storeClassOffline,
    },
    {
      //提币变动记录
      path: "/user/integralWithdrawalList",
      name: "userWithdraw",
      component: userWithdraw,
    },
    {
      //供应商列表
      path: "/store/list",
      name: "storeList",
      component: storeList,
    },
	{
	  //员工列表
	  path: "/store/employeeList",
	  name: "employeeList",
	  component: employeeList,
	},
	{ //用户管理
		path: '/card/cardManagement',
		name: 'cardManagement',
		meta:{keepAlive: true},    // 是否缓存组件
		// component: cardManagement,   
		component: () => import('../views/card/cardManagement.vue'),
	},
	{ //用户管理
		path: '/card/cardyslist',
		name: 'cardyslist',
		// meta:{keepAlive: true},    // 是否缓存组件
		component: cardyslist,   
		// component: () => import('../views/card/cardyslist.vue'),
	},
	
	{ //用户管理
		path: '/card/recordList',
		name: 'recordList', 
		// meta:{keepAlive: true}, // 是否缓存组件
		component: recordList,
	},
	{ //用户管理
		path: '/card/cardrecord',
		name: 'cardrecord', 
		meta:{keepAlive: true}, // 是否缓存组件
		component: cardrecord,
	},
	{
	  //分销列表
	  path: "/store/fxList",
	  name: "fxList",
	  component: fxList,
	},
	{
	  //供应商列表
	  path: "/store/Pplist",
	  name: "Pplist",
	  component: Pplist,
	},
	{
	  //供应商列表
	  path: "/store/Ppclass",
	  name: "Ppclass",
	  component: Ppclass,
	},
    {
      //云库审核管理列表
      path: "/store/cloudList",
      name: "cloudList",
      component: cloudList,
    },
    {
      //商品列表
      path: "/goods/list",
      name: "goodsList",
      component: goodsList,
    },
	{
	  //商品列表
	  path: "/goods/offinegoods",
	  name: "offinegoods",
	  component: offinegoods,
  },
  {
	  // 云连锁商品列表
	  path: "/goods/PpGoods",
	  name: "PpGoods",
	  component: PpGoods,
	},
	{
	  //商品列表
	  path: "/goods/goodsDetail",
	  name: "goodsDetail",
	  component: goodsDetail,
	},
	{
	  //商品列表
	  path: "/goods/updateProductAttr",
	  name: "updateProductAttr",
	  component: updateProductAttr,
	},
	{
	  //商品列表
	  path: "/goods/addProductAttr",
	  name: "addProductAttr",
	  component: addProductAttr,
	},
	{
	  //商品列表
	  path: "/store/expressList",
	  name: "expressList",
	  component: expressList,
	},
	{
	  //商品列表
	  path: "/store/Jobsharing",
	  name: "Jobsharing",
	  component: Jobsharing,
	},
	{
	  //店铺消息
	  path: "/message/storeMessage",
	  name: "storeMessage",
	  component: storeMessage,
	},
	
	{
	  //商品列表
	  path: "/store/storeexpress",
	  name: "storeexpress",
	  component: storeexpress,
	},
	
	{
	  //商品列表
	  path: "/goods/productAttrList",
	  name: "productAttrList",
	  component: productAttrList,
	},

    {
      //社区商品列表
      path: "/storeOffline/listOffline",
      name: "goodsListOffline",
      component: goodsListOffline,
    },
    {
      //订单管理
      path: "/orderManagement/orderMang",
      name: "orderMang",
      component: orderMang,
    },
    {
      //订单管理
      path: "/orderManagement/orderList",
      name: "orderList",
      component: orderList,
    },
	{
	  //订单管理
	  path: "/orderManagement/ssorderList",
	  name: "ssorderList",
	  component: ssorderList,
	},
  {
    //联盟订单
    path: "/orderManagement/allianceOrderList",
    name: "allianceOrderList",
    component: allianceOrderList,
  },
    {
      //社区订单管理
      path: "/storeOffline/orderListOffline",
      name: "orderListOffline",
      component: orderListOffline,
    },
    {
      //预约排单管理
      path: "/appomplt/apmScheduling",
      name: "scheduling",
      component: scheduling,
    },
    {
      //抢单额度管理
      path: "/appomplt/orderGrabbing",
      name: "orderGrabbing",
      component: orderGrabbing,
    },
    {
      //物流管理
      path: "/logistics/index",
      name: "logistics",
      component: logistics,
    },
    {
      //省市区
      path: "/logistics/threeLevelAddress",
      name: "threeLevelAddress",
      component: threeLevelAddress,
    },
    {
      //导航栏
      path: "/carousel/swiper",
      name: "swiper",
      component: swiper,
    },
    {
      //酒柜管理
      path: "/store/wineCooler",
      name: "wineCooler",
      component: wineCooler,
    },
    {
      //质押管理
      path: "/pledgemanage/pledgemanage",
      name: "pledgemanage",
      component: pledgemanage,
    },
    {
      //质押明细
      path: "/pledgemanage/pledgeDetail",
      name: "pledgeDetail",
      component: pledgeDetail,
    },
    {
      //质押记录
      path: "/pledgemanage/pledgeRecord",
      name: "pledgeRecord",
	  
      component: pledgeRecord,
    },
    {
      //质押期数
      path: "/pledgemanage/pledgePowerRecord",
      name: "pledgePowerRecord",
      component: pledgePowerRecord,
    },
    {
      //底池
      path: "/pledgemanage/bottomBasin",
      name: "bottomBasin",
      component: bottomBasin,
    },
    {
      //大区业绩日报表
      path: "/pledgemanage/performanceReport",
      name: "performanceReport",
      component: performanceReport,
    },
    {
      //大区业绩月报表
      path: "/pledgemanage/perfoReportmouth",
      name: "perfoReportmouth",
      component: perfoReportmouth,
    },
    {
      //供应商管理
      path: "/store/storeManage",
      name: "storeManage",
      component: storeManage,
    },
    {
      //酒柜管理里面的商品列表
      path: "/storeOffline/productList",
      name: "productList",
      component: productList,
    },
    {
      //酒柜列表
      path: "/storeOffline/wineCabinetList",
      name: "wineCabinetList",
      component: wineCabinetList,
    },
    {
      //促销审核管理
      path: "/dPromotion/promoTion",
      name: "promoTion",
      component: promoTion,
    },
    {
      //折扣促销列表
      path: "/dPromotion/promList",
      name: "promList",
      component: promList,
    },
    {
      // 加入选品
      path: "/dPromotion/fxlist",
      name: "fxlist",
      component: fxlist,
    },
    {
      // 加入选品
      path: "/notify/list",
      name: "notify",
      component: notify,
    },
    { //广告类型列表
      path: '/notify/advertisingTypeList',
      name: 'advertisingTypeList',
      component: advertisingTypeList,
    },
    {
      // 选品库
      path: "/dPromotion/selectionlist",
      name: "selectionlist",
      component: selectionlist,
    },
    {
      //商户提现
      path: "/mrRction/mrRcList",
      name: "mrRcList",
      component: mrRcList,
    },
    {
      //商户提现管理
      path: "/mrRction/mantWithManagement",
      name: "mantWithManagement",
      component: mantWithManagement,
    },
    {
      //提现管理
      path: "/mrRction/withdManagement",
      name: "withdManagement",
      component: withdManagement,
    },
    {
      //质押、供应申请
      path: "/mrRction/creditList",
      name: "creditList",
      component: creditList,
    },
    {
      // 信用分变动查询
      path: "/mrRction/CreditScoreList",
      name: "CreditScoreList",
      component: CreditScoreList,
    },
    {
      //定存列表
      path: "/fixDeposit/fixdList",
      name: "fixdList",
      component: fixdList,
    },
    {
      //定存管理
      path: "/fixDeposit/fixManage",
      name: "fixManage",
      component: fixManage,
    },
    {
      //推荐分类管理类
      path: "/goods/remondClass",
      name: "remondClass",
      component: remondClass,
    },
    {
      //店铺经营类别
      path: "/store/bniesCategory",
      name: "bniesCategory",
      component: bniesCategory,
    },
	{
	  //店铺经营类别
	  path: "/store/setoffstore",
	  name: "setoffstore",
	  component: setoffstore,
	},
	
    {
      //供应商商品管理
      path: "/goods/goodSupplierlist",
      name: "goodSupplierlist",
      component: goodSupplierlist,
    },
    {
      //供应商订单管理
      path: "/orderManagement/orederSupplerlist",
      name: "orederSupplerlist",
      component: orederSupplerlist,
    },
    {
      //区域代理管理
      path: "/regionalAgent/index",
      name: "regionalAgent",
      component: regionalAgent,
    },
    {
      // 抢购活动
      path: "/goods/robOrder",
      name: "robOrder",
      component: robOrder,
    },
    {
      // 抢购预约记录
      path: "/goods/orderRecords",
      name: "orderRecords",
      component: orderRecords,
    },
    {
      // 采购订单管理
      path: "/orderManagement/orderPurchaselist",
      name: "orderPurchaselist",
      component: orderPurchaselist,
    },
    {
      // 会员买单记录
      path: "/otc/buyRecords",
      name: "buyRecords",
      component: buyRecords,
    },
    {
      // OTC挂卖订单
      path: "/otc/saleRecords",
      name: "saleRecords",
      component: saleRecords,
    },
    {
      // OTC价格变动
      path: "/otc/priceChange",
      name: "priceChange",
      component: priceChange,
    },
    {
       // OTC记录
       path: "/otc/otcList",
       name: "otcList",
       component: otcList,
    },
    {
      // 经销商月度业绩
      path: "/dealer/dealerMPerformance",
      name: "dealerMPerformance",
      component: dealerMPerformance,
    },
    {
      // 资产变动记录-历史记录
      path: "/user/recordHistory",
      name: "recordHistory",
      component: recordHistory,
    },
    {
      // 订单历史记录
      path: "/orderManagement/orderHistory",
      name: "orderHistory",
      component: orderHistory,
    },
    {
      // 充值记录-审核
      path: "/user/pay",
      name: "pay",
      component: pay,
    },
    {
      // 充值记录-审核
      path: "/user/glypay",
      name: "glypay",
      component: glypay,
    },
    {
      // 消息管理 - 类型
      path: "/message/messagesType",
      name: "messagesType",
      component: messagesType,
    },
    {
      // 消息管理 - 列表
      path: "/message/systemMessages",
      name: "systemMessages",
      component: systemMessages,
    },
    {
      // 反馈建议 - 类型
      path: "/feedback/feedbackType",
      name: "feedbackType",
      component: feedbackType,
    },
    {
      // 反馈建议 - 记录列表
      path: "/feedback/queryFeedbackNode",
      name: "queryFeedbackNode",
      component: queryFeedbackNode,
    },
	{//课程列表
		path:'/course/courseList',
		name:'courseList',
		component:courseList
  },
  {//课程列表
  		path:'/user/emaillist',
  		name:'emaillist',
  		component:emaillist
  },
  {//课程列表
  		path:'/user/mblist',
  		name:'mblist',
  		component:mblist
  },
  {//课程列表
  		path:'/user/aiorder',
  		name:'aiorder',
  		component:aiorder
  },
  
  {
    //帮助中心
    path: "/help/helpList",
    name: "helpList",
    component: helpList,
  },
  {
    //帮助中心
    path: "/help/helpTypeList",
    name: "helpTypeList",
    component: helpTypeList,
  },
    { //客户反馈
      path: "/feedback/customerFeedback",
      name: "customerFeedback",
      component: customerFeedback,
    },
    { //扫码付款破纪录
      path: "/store/paymentByCode",
      name: "paymentByCode",
      component: paymentByCode,
    },
    {
      // 短视频
      path: "/shortVideo/list",
      name: "videoList",
      component: videoList,
    },
    {
      //订单售后列表
      path: "/orderManagement/orderAfterSale",
      name: "orderAfterSale",
      component: orderAfterSale,
    },
    {
      //采购订单
      path: "/orderManagement/caiGouOrderList",
      name: "caiGouOrderList",
      component: caiGouOrderList,
    },
    {
      // 生活缴费
      path: "/livingPayment/paymentList",
      name: "paymentList",
      component: paymentList,
    },
    {
      // 案例列表
      path: "/facilitator/caseList",
      name: "caseList",
      component: caseList,
    },
    {  // 服务商月度业绩统计表
      path: "/facilitator/fwsMonthResult",
      name: "fwsMonthResult",
      component: fwsMonthResult,
    },
    { // 商家月度业绩统计表
      path: "/store/storeMonthResult",
      name: "storeMonthResult",
      component: storeMonthResult,
    },
    {
      // 商家资产变动
      path: "/store/assetChanges",
      name: "assetChanges",
      component: assetChanges,
    }
  ],
});
